import React from 'react';
import { Typography } from '@mui/material';
import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { SettingDisplayText } from 'components/settings/SettingDisplayText';

export const EagleEyeGiftCardSettingsDisplay: React.FC<IPointOfSaleSettingsProps> = ({
    settings,
    locationId
}) => {
    const campaignIds = React.useMemo(
        () => settings?.eagleEye?.fullRedemptionOnlyCampaignIds || [],
        [settings]
    );
    return (
        <>
            {/* Common Only */}
            {locationId === undefined && (
                <SettingDisplayText
                    title="Campaign Ids"
                    text={
                        <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                            {campaignIds.slice(0, 5).join(', ')}
                            {campaignIds.length > 5 && ` ... ${campaignIds.length - 5} more`}
                        </Typography>
                    }
                />
            )}
        </>
    );
};
